<template>
  <el-drawer
    title="Registrar Dispositivos"
    :size="drawerSize"
    :visible.sync="drawer"
    :before-close="handleClose"
    v-loading="loadingD"
    class="drawer-scroll"
  >
    <el-container class="drawer-body">
      <el-main>
        <el-form :model="model" ref="form">
          <el-form-item label-width="0">
            <el-col>
              <span>{{ title }} </span>
            </el-col>
          </el-form-item>

          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(d, index) in model.devices"
              :key="index"
              :title="d.title"
              :name="index"
            >
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="{ maxScrollbarLength: 60, wheelPropagation: true }"
              >
                <el-row>
                  <el-col>
                    <template v-for="(d2, index2) in d.devices">
                      <el-row
                        type="flex"
                        :gutter="5"
                        align="center"
                        :key="index2"
                      >
                        <el-col
                          :span="2"
                          :xs="24"
                          :sm="24"
                          :lg="2"
                          class="mr-5"
                        >
                          <span>Technico:</span>
                        </el-col>
                        <el-col :span="5" :xs="24" :sm="24" :lg="5">
                          <span class="text-bold">{{
                            d2.technical.FullName
                          }}</span>
                        </el-col>
                      </el-row>

                      <el-row
                        :key="index2 + 0.1"
                        :gutter="5"
                        align="center"
                        style="margin-bottom: 0 !important"
                      >
                        <el-col :span="5" :md="5" :xs="24" :sm="24" :lg="3">
                          <el-form-item
                            label-width="0"
                            :prop="`${index}_${index2}_model`"
                          >
                            <el-select
                              v-model="d2.emei"
                              placeholder="Modelo"
                              clearable
                              filterable
                              remote
                              reserve-keyword
                              :loading="loadingDict.model"
                              :remote-method="remoteMethodModel"
                              @change="
                                model[`${index}_${index2}_emei`] = $event
                              "
                            >
                              <el-option
                                v-for="(item, index3) in d2.emei_list"
                                :key="index3"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option
                            ></el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="5" :md="5" :xs="24" :sm="24" :lg="3">
                          <el-form-item
                            label-width="0"
                            :prop="`${index}_${index2}_sim`"
                          >
                            <el-select
                              v-model="d2.sim"
                              @change="model[`${index}_${index2}_sim`] = $event"
                              placeholder="SIM"
                              clearable
                              filterable
                              remote
                              reserve-keyword
                              :loading="loadingDict.sim"
                              :remote-method="remoteMethodSim"
                            >
                              <el-option
                                v-for="(item, index4) in d2.sim_list"
                                :key="index4"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="5" :md="10" :xs="24" :sm="24" :lg="10">
                          <el-form-item
                            label-width="0"
                            :prop="`${index}_${index2}_label`"
                          >
                            <el-input
                              v-model="d.label"
                              @input="
                                model[`${index}_${index2}_label`] = $event
                              "
                              placeholder="Titulo"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                  </el-col>
                </el-row>
              </VuePerfectScrollbar>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-main>
      <el-footer>
        <el-row type="flex">
          <el-col :sm="24" :span="4" :xs="24" :lg="4" :md="4">
            <el-button type="primary" @click="onSubmit" size="small"
              >Guardar</el-button
            >
          </el-col>
          <el-col :sm="24" :span="4" :xs="24" :lg="4" :md="4">
            <el-button type="danger" @click="drawer = false" size="small"
              >Cancelar</el-button
            >
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-drawer>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapActions } from "vuex";
import { formatArrayToElSelect } from "@/utils";
import { technicians } from "@/views/modules/technical_support/requests/requests";
import { NAME_REQUEST_DEMO } from "@/const";

export default {
  name: "RegisterDevices",
  components: {
    VuePerfectScrollbar
  },
  updated() {
    if (window.innerWidth <= 480) {
      this.drawerSize = "100%";
    } else {
      this.drawerSize = "70%";
    }
  },
  data() {
    return {
      activeNames: [0],
      acr: {},
      drawer: false,
      model: {
        devices: []
      },
      request: {},
      textLoading: "Loading",
      technicians: technicians,
      availableDevices: null,
      availableSIM: null,
      loadingD: false,
      loadingDict: { sim: false, model: false },
      describeRequestType: "",
      drawerSize: "70%"
    };
  },
  methods: {
    formatArrayToElSelect,
    ...mapActions("inventory", ["getAvailableDevices", "getAvailableSIMS"]),
    ...mapActions("navixy", ["activeGpsDemo"]),
    handleClose(done) {
      this.$refs.form.resetFields();
      done();
    },
    async show(request) {
      const { ServiceRequestType } = request;
      const { Description } = ServiceRequestType;
      this.describeRequestType = Description;

      this.model.devices = [];
      const request_id = request.Id;

      const loading = this.$loading({
        lock: true,
        text: this.textLoading,
        spinner: "el-icon-loading"
      });

      try {
        loading.text = "Cargando solicitud";
        const request = await this.$http
          .get(`/api/serviceRequests/${request_id}/details`)
          .then(({ data }) => data);
        this.request = request;

        if (request.DeviceOperationRequests.length > 0) {
          loading.text = "Cargando lista de modelos";
          const availableDevices = await this.getAvailableDevices({
            product_code: request.Product.Codes,
            fixed_asset_type: 1
          });

          this.availableDevices = this.formatArrayToElSelect(availableDevices, {
            label: "IMEI",
            value: "IMEI"
          });

          const availableSIM = await this.getAvailableSIMS({});

          this.availableSIM = this.formatArrayToElSelect(availableSIM, {
            label: "PhoneNumber",
            value: "PhoneNumber"
          });

          loading.text = "Renderizando";

          for (
            let index = 0;
            index < this.request.DeviceOperationRequests.length;
            index++
          ) {
            this.acr[index] = [0];

            const element = this.request.DeviceOperationRequests[index];
            const { Quantity } = element;

            let devs = [];

            for (let i2 = 0; i2 < Quantity; i2++) {
              const dev = {
                title: element.Device.Description,
                emei_list: this.availableDevices.slice(0, 10),
                sim_list: this.availableSIM.slice(0, 10),
                technical: element.Technician,
                technical_id: element.TechnicianId,
                DeviceTypeId: element.DeviceTypeId,
                require_sim: element.DeviceType.RequiresSIM,
                DeviceOperationRequestId: element.Id,
                ...element
              };
              devs.push(dev);

              this.model[`${index}_emei`] = null;
              this.model[`${index}_sim`] = null;
              this.model[`${index}_label`] = null;
            }

            this.model.devices.push({
              title: element.Device.Description,
              devices: devs
            });
          }
        }

        this.drawer = true;
        loading.close();
      } catch (error) {
        console.error(error);
        this.drawer = false;
        loading.close();
      }
    },
    onSubmit() {
      this.loadingD = true;

      this.$refs.form.validate((valid) => {
        if (valid) {
          const { Codes: product_code } = this.request.Product;
          const body = {
            RequestId: this.request.Id,
            UserId: this.currentUser.UserID,
            Request: this.request,
            // InstallationRequests: [],
            LocationCode: product_code,
            Devices: []
          };

          for (let index = 0; index < this.model.devices.length; index++) {
            const { devices } = this.model.devices[index];

            for (let i2 = 0; i2 < devices.length; i2++) {
              const element = devices[i2];
              //console.log("element -->", element);
              try {
                const result = this.availableDevices.filter(
                  (item) =>
                    item.value
                      .toLowerCase()
                      .indexOf(element.emei.toLowerCase()) > -1
                );

                body.Devices.push({
                  DeviceOperationRequestId: element.DeviceOperationRequestId,
                  HaveSIMCard: result[0].HaveSIMCard,
                  IMEI: element.emei,
                  SIMNumber: element.sim, // comente el anterior porque le pasa siempre el serial en lugar del sim
                  //SIMNumber:
                  //result[0].SIMNumber ?? `${result[0].SIMNumber}`.trim(),
                  Serial: result[0].Serial ?? `${result[0].Serial}`.trim(),
                  SimIMEI: result[0].SimIMEI ?? `${result[0].SimIMEI}`.trim()
                });
              } catch {
                /* continua con el proceso, para que en la segunda iteraccion sea ingnorada */
              }
            }
          }

          this.$http
            .post("/api/serviceRequests/registerDevices", body)
            .then(({ data }) => {
              const { Succeded, Message } = data;
              this.loadingD = false;
              if (Succeded === true) {
                /*this.drawer = false;*/
                this.$message.success("La operacion fue exitosa.");
                /*
								si la solicitud es de tipo demo entonces no queremos
								que valide el usuario ya que el usario navixy a usar
								es el user demo. */
                if (
                  this.describeRequestType.toLowerCase().trim() ===
                  NAME_REQUEST_DEMO.toLowerCase()
                ) {
                  this.showModalActiveDemo();
                } else {
                  window.location.reload();
                  this.loadingD = false;
                }
              } else {
                this.$message.error(Message);
                this.loadingD = false;
                return false;
              }
            })
            .catch((error) => {
              console.error(error);
              this.$message.error("La operacion a fallado.");
              this.loadingD = false;
            });
        } else {
          this.loadingD = false;
          return false;
        }
      });
    },
    remoteMethodSim(query) {
      this.loadingDict.sim = true;
      setTimeout(() => {
        this.loadingDict.sim = false;
        const result = this.availableSIM.filter(
          (item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        );

        for (let index = 0; index < this.model.devices.length; index++) {
          const element = this.model.devices[index];
          const { devices } = element;

          for (let i2 = 0; i2 < devices.length; i2++) {
            devices[i2].sim_list = result;
          }
        }
      }, 100);
    },
    remoteMethodModel(query) {
      this.loadingDict.model = true;
      setTimeout(() => {
        this.loadingDict.model = false;

        const result = this.availableDevices.filter(
          (item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        );

        for (let index = 0; index < this.model.devices.length; index++) {
          const element = this.model.devices[index];
          const { devices } = element;

          for (let i2 = 0; i2 < devices.length; i2++) {
            devices[i2].emei_list = result;
          }
        }
      }, 100);
    },
    showModalActiveDemo() {
      this.$confirm("Desea activar el demo?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          for (let index = 0; index < this.model.devices.length; index++) {
            const element = this.model.devices[index];

            // TODO: model es el codigo para usar (esto es de navixy)
            // se debe agregar en la tabla device este campo.
            // TODO: se debe investigar los demas devises, luego se debe
            // modificar este codigo.
            let model = "";
            if (element.Device.Description === "TK206") {
              model = "gotoptk206";
            }

            if (model !== "") {
              this.activeGpsDemo({
                label: element.label,
                model: model,
                device_id: element.emei,
                phone: element.sim
              })
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "Activacion de demo exitosa"
                  });
                })
                .catch((error) => {
                  console.error(error);
                  this.$message({
                    type: "error",
                    message: "Error en la activacion del demo"
                  });
                });
            }
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Activacion de demo cancelada"
          });
        })
        .finally(() => {
          this.loadingD = false;
          window.location.reload();
        });
    }
  },
  computed: {
    deviceQuantity() {
      return this.request.DeviceQuantity;
    },
    sumQuantity() {
      return this.model.devices
        .map((d) => d.quantity)
        .reduce((acc, cur) => acc + cur);
    },
    restQuantity() {
      return Math.abs(this.sumQuantity - this.deviceQuantity);
    },
    checkQuantity() {
      return this.deviceQuantity === this.sumQuantity;
    },
    hiddenAddDev() {
      return this.model.devices.length === this.deviceQuantity;
    },
    title() {
      if (Object.keys(this.request).length <= 0) {
        return "";
      }

      return `(${this.request.DeviceQuantity}) ${this.request.RequestDeviceTypeQuantities[0].DeviceType.Description} de ${this.request.ServiceRequestType.Description}`;
    }
  }
};
</script>

<style lang="scss">
.drawer-body {
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 600px;
}

.drawer-scroll {
  .el-drawer {
    height: 100%;
    overflow: scroll;
  }
}
</style>
